export default __webpack_public_path__ + "static/fb-share-default-957a941f39b855d723d579e05197081f.jpg";